import { Switch } from '@billy/design-system'
import styled from '@emotion/styled'

export const PriceFlipSwitch = styled(Switch)`
  width: 40px;
  margin: 0 10px;
`
